<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 16 16"
  >
    <path
      :stroke="color"
      fill="none"
      d="M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
    />
    <path
      v-show="checked"
      :fill="color"
      d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
    />
    <!-- <path stroke="#3E9AA6" d="M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"/>
    <path fill="#3E9AA6" d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/> -->
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

const tinycolor = require('tinycolor2');

export default {
  components: {
    BaseIcon,
  },
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 16,
    },
    height: {
      type: [Number, String],
      default: 16,
    },
  },
  computed: {
    isDarkBg() {
      return tinycolor(this.color).isDark();
    },
    borderColor() {
      const tColor = tinycolor(this.color);
      return this.isDarkBg
        ? tColor.lighten(5).toString()
        : tColor.darken(5).toString();
    },
  },
};
</script>
